/** @format */

import { createClient } from "@supabase/supabase-js";
import type { Database } from "@lib/supabase/db.types";

export default createClient<Database>(
 process.env.SUPABASE_URL!,
 process.env.SUPABASE_ANON_KEY!
);
